export default __webpack_public_path__ + "static/sample-signature-c84d6f5238b0636cadef449351e08877.svg";